
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import HistoryNoSign from '../../components/course/history-no-sign.vue'
import signLoges from '../../components/course/sign-loges.vue'
  @Component({
    name: 'TableNoSign',
    components: { HistoryNoSign, signLoges }
  })
export default class TableNoSign extends Vue {
    @Prop() isNew: boolean
    @Prop() tableSignData: any
    @Prop() signHistoryList: any
    @Prop() dialogZskNoSystem: boolean
    @Prop() materialList: any
    @Prop() getStudentLevelList: any
    @Prop() sign_title: string
    @Prop() student_id: string


    @Watch('dialogZskNoSystem')
    dialog(newVal, oldVal) {
      if(newVal) {
        this.action = true
        this.getListNew()
      }
    }

    addnotCustomer: any = {
      sign_title: '',
      student_name: '',
      teacherRemark: '',
      subject_remark: '',
      materialSelect: [],
      studentRemark: '',
      material_remark: '',
      selectStudentLevel: ''
    } // 非体系课
  

    is_show_history: boolean = false
    history_sign_time: string = ''
    historyList: any = {}
    p_hight: any = window.innerHeight - 80 + 'px'
    action: boolean = false
    logHeight: number = 0

    changeSelectMaterial(val) {
      this.addnotCustomer.materialSelect = val
    }

    getHeight() {
      window.onresize = () => {
        this.p_hight = window.innerHeight - 80 + 'px'
      }
    }

    getListNew() {
      if(this.tableSignData && this.tableSignData.student_info && this.tableSignData.student_info.id) {
        this.is_show_history = true
      } else {
        this.is_show_history = false
      }
      this.history_sign_time = this.tableSignData.history_sign_time
      this.historyList = this.tableSignData.student_info
      this.addnotCustomer.sign_title = this.tableSignData.history_sign_time
      this.addnotCustomer.student_name = this.tableSignData.student_info.student_name
      this.addnotCustomer.material_remark = this.tableSignData.student_info.material_remark
      this.addnotCustomer.teacherRemark = this.tableSignData.student_info.teacher_remark
      this.addnotCustomer.studentRemark = this.tableSignData.student_info.student_remark
      this.addnotCustomer.subject_remark = this.tableSignData.student_info.subject_remark
      this.addnotCustomer.selectStudentLevel = this.tableSignData.student_info.sign_student_level_id

      if(this.tableSignData.student_info.material_id) {
        this.addnotCustomer.materialSelect =  (this.tableSignData.student_info.material_id).split(',')
      } else {
        this.addnotCustomer.materialSelect =  []
      }


      
      this.$nextTick(function () {
        this.logHeight = this.$refs.getheight['offsetHeight']
      })
    }
    handleZskSignClose() {
      this.$emit('close-table-no-sign', {type: false})
      this.action = false
    }
    handleZskSignTrue() {
      const material_id = this.addnotCustomer.materialSelect.join(',')
      let data = {
        'sign_type': 1,
        'course_type': 1,
        'material_id': material_id,
        'student_remark': this.addnotCustomer.studentRemark,
        'teacher_remark': this.addnotCustomer.teacherRemark,
        'material_remark': this.addnotCustomer.material_remark,
        'subject_remark': this.addnotCustomer.subject_remark,
        'sign_student_level_id': this.addnotCustomer.selectStudentLevel
      }

      this.$emit('close-table-no-sign', {type: true, data: data, isNew: this.isNew})
      this.action = false
    }
    mounted() {
      this.getHeight()
    }
}
